import { render, staticRenderFns } from "./investment-resume.component.vue?vue&type=template&id=92335440&scoped=true"
import script from "./investment-resume.component.vue?vue&type=script&lang=js"
export * from "./investment-resume.component.vue?vue&type=script&lang=js"
import style0 from "./investment-resume.component.vue?vue&type=style&index=0&id=92335440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92335440",
  null
  
)

export default component.exports